import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnBoardTransitionService {
  private transitionState = new BehaviorSubject<'in' | 'out'>('in');
  private nextRoute = new BehaviorSubject<string | null>(null);

  transition$ = this.transitionState.asObservable();
  route$ = this.nextRoute.asObservable();

  startTransition(toRoute: string) {
    this.nextRoute.next(toRoute);
    this.transitionState.next('out');
  }

  completeTransition() {
    this.transitionState.next('in');
    this.nextRoute.next(null);
  }

  getPendingRoute(): string | null {
    return this.nextRoute.getValue();
  }
}
